module.exports = __webpack_public_path__ + "img/5.7306d641.png";